<template>
	<div class="house-selection__bottom">
		<div class="map">
      <div
        v-if="facadeIsLoaded && facade"
      >
        <img class="house-selection-img" alt=""
          :src="facade.image"
        >
  
        <svg class="map-svg"
          v-bind:viewBox="`0 0 ${ imgWidth } ${ imgHeight }`"
        >
          <foreignObject x="50" y="250" style="width: 445px; height: 517px; transform: scale(1);">
            <div style="width: 100%; height: 100%; background: rgba(255, 255, 255, .9); border-radius: 5px; font-family: Arial, Helvetica, sans-serif;">
              <div style="padding: 23px 40px 46px; height: 100%; display: flex; flex-direction: column;">
                <div style="font-style: normal; font-weight: 400; font-size: 48px; line-height: 58px; text-transform: uppercase; color: #383C3E; margin-bottom: 2px;">
                  ЖК ТОПАЗ
                </div>
                <div style="font-size: 15px; line-height: 180%; color: #443E35; opacity: 0.7; margin-bottom: 25px;">
                  79 квартир
                </div>
                <div style="flex-grow: 1;">
                  <table style="width: 100%; border-collapse: separate; border-spacing: 0 8px;">
                    <tr style="font-weight: 400; font-size: 15px; line-height: 180%; color: #383C3E; opacity: 0.7;">
                      <td>Тип</td>
                      <td>Площадь, м2</td>
                    </tr>
                    <tr style="font-weight: 400; font-size: 20px; line-height: 180%; color: #000000;">
                      <td>1-комнатные</td>
                      <td style="font-size: 18px;">38,94-43,69</td>
                    </tr>
                    <tr style="font-weight: 400; font-size: 20px; line-height: 180%; color: #000000;">
                      <td>2-комнатные</td>
                      <td style="font-size: 18px;">63,92-72,17</td>
                    </tr>
                    <tr style="font-weight: 400; font-size: 20px; line-height: 180%; color: #000000;">
                      <td>3-комнатные</td>
                      <td style="font-size: 18px;">87,31-88,19</td>
                    </tr>
                    <tr style="font-weight: 400; font-size: 20px; line-height: 180%; color: #000000;">
                      <td>4-комнатные</td>
                      <td style="font-size: 18px;">147,10</td>
                    </tr>
                  </table>
                </div>
                <button type="button" style="outline: none; background-color: transparent; width: 100%; height: 55px; padding: 13px 35px; border: 1px solid #000000;"
                  @click="$emit( 'go-to-list' )"
                >
                  <span style="font-weight: 400; font-size: 15px; line-height: 18px; letter-spacing: 0.1em; text-transform: uppercase; color: #000000;">
                    Смотреть все квартиры
                  </span>
                </button>
              </div>
            </div>
          </foreignObject>
          <g
            style="transform: scaleY(-1) translateY(-100%); -webkit-transform: scaleY(-1) translateY(-100%);"
          >
            <g
              v-for="area of facade.areas"
              :key="area.id"
            >
              <polygon class="map-polygon"
                :style="{
                  'pointer-events': isFloorExist( area ) ? 'none' : 'inherit',
                  ...( isFloorExist( area ) ? ( { display: 'none' } ) : {} ),
                }"
                :points="area.coordinates.map( coordinate => `${ coordinate[0] },${ coordinate[1] }` ).join(' ')"
                @click="selectArea( area )"
              ></polygon>
              <foreignObject width="103" height="46"
                :x="getXByArea( area )"
                :y="getYByArea( area ) - 23"
                style="pointer-events: none; overflow: visible;"
              >
                <div style="position: fixed; display: inline-flex; height: 46px; padding: 0 14px; background-color: #FFF; border-radius: 6px; align-items: center; gap: 10px;"
                  class="floor-placeholder"
                  :class="{ 'floor-placeholder_safari': isSafari }" 
                  :style="labelStyle"
                >
                  <div style="width: 23px; height: 23px; border-radius: 50%; background: #302E2A; font-size: 13px; line-height: 13px; color: #FFF; display: flex; align-items: center; justify-content: center;">{{ area.floorNumber }}</div>
                  <div style="font-size: 16px;line-height: 19px; color: #383C3E;">Этаж</div>
                </div>
              </foreignObject>
            </g>
          </g>
        </svg>
      </div>
    </div>
	</div>
</template>

<script>
  import profitbaseReguestService from '@/shared/requests/profitbaseReguestService'
  
  import { token } from '@/shared/axios/profitbase/store'

  import { houseId, selectedArea, houseFloorsCount } from '@/modules/house/state'

  import { floorList, propertyList } from '@/modules/floor/store'

  export default {
    setup() {
      return { houseId, selectedArea, houseFloorsCount, floorList, propertyList }
    },

    data() { return {
      facade: {},
      facadeIsLoaded: false,
      imgWidth: 0,
      imgHeight: 0,
      isSafari: false
    } },

    methods: {
      selectArea( area ) {
        this.selectedArea = area
      },

      isFloorExist( area ) {
        return !this.floorList.find( floor => floor.number === area.floorNumber )
      },

      getXByArea( area ) {
        try {
          const min = Math.min( ...area.coordinates.map( el => el[ 0 ] ) )
          const max = Math.max( ...area.coordinates.map( el => el[ 0 ] ) )
          return ( min + ( ( max - min ) / 2 ) )
        } catch( e ) {
          return null
        }
      },
      getYByArea( area ) {
        try {
          const min = Math.min( ...area.coordinates.map( el => el[ 1 ] ) )
          const max = Math.max( ...area.coordinates.map( el => el[ 1 ] ) )
          return ( min + ( ( max - min ) / 2 ) )
        } catch( e ) {
          return null
        }
      },

      getCursorXByArea( area ) {
        try {
          const max = Math.max( ...area.coordinates.map( el => el[ 0 ] ) )
          return max
        } catch( e ) {
          return null
        }
      },
      getCursorYByArea( area ) {
        try {
          const sorted = area.coordinates.toSorted( ( a, b ) => a[ 0 ] - b[ 0 ] )
          const [ preLast, last ] = [ sorted.at( -1 ), sorted.at( -2 ) ]
          const min = Math.min( ...[ preLast, last ].map( el => el[ 1 ] ) )
          const max = Math.max( ...[ preLast, last ].map( el => el[ 1 ] ) )
          return ( min + ( ( max - min ) / 2 ) )
        } catch( e ) {
          return null
        }
      }
    },

    computed: {
      labelStyle() {
        // if ( /^((?!chrome|android).)*safari/i.test(navigator.userAgent) )
        //   return {
        //     transform: 'translateY(-100%) scale(1.3)',
        //     '-webkit-transform': 'translateY(-100%) scale(1.3)'
        //   }
        // return {
        //   transform: 'scaleY(-1) scale(2)',
        //   '-webkit-transform': 'scaleY(-1) scale(2)'
        // }
      }
    },

    mounted() {
      this.isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

      this.propertyList = []

      profitbaseReguestService.getFacade( { token: token.value, houseId: this.houseId } )
        .then( response => {
          this.facade = response.data[ 0 ]
          this.facadeIsLoaded = true

          const img = new Image()
          img.addEventListener( 'load', () => {
            [ this.imgWidth, this.imgHeight ] = [ img.naturalWidth, img.naturalHeight ]
          })
          img.src = this.facade.image
        } )

      profitbaseReguestService.getHouseFloorsCount( { token: token.value, houseId: this.houseId } )
        .then( response => {
          this.houseFloorsCount = Math.max( ...response.data.data.map( el => el.count ) );
        } )
      
      profitbaseReguestService.getFloorList( { token: token.value, houseId: this.houseId } )
        .then( response => {
          this.floorList = response.data
        } )
        
      profitbaseReguestService.getPropertyList( { token: token.value, houseId: this.houseId, full: true } )
        .then( response => {
          this.propertyList.push( ...response.data.data )
        } )
        
      profitbaseReguestService.getPropertyList( { token: token.value, houseId: this.houseId, full: true, offset: 100 } )
        .then( response => {
          this.propertyList.push( ...response.data.data )
        } )
    }
  }
</script>

<style>
  .map {
    position: relative;
  }

  .map-svg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .map-polygon {
    stroke-width: 1;
    cursor: pointer;
    fill: transparent;
    stroke-width: 1px;
  }

  .map-polygon:hover {
    fill: rgba(48, 46, 42, .7);
  }

  .map-polygon + foreignObject {
    display: none;
  }
  .map-polygon:hover + foreignObject {
    display: block;
  }

  .floor-placeholder {
    transform: scaleY(-1);
    -webkit-transform: scaleY(-1);
  }

  .floor-placeholder_safari {
    transform: translateY(-100%);
    -webkit-transform: translateY(-100%);
  }

  @media (max-width: 1200px) {
    .floor-placeholder {
      transform: scaleY(-1) scale(3.5);
      -webkit-transform: scaleY(-1) scale(3.5);
    }

    .floor-placeholder_safari {
      transform: translateY(-100%) scale(3.5);
      -webkit-transform: translateY(-100%) scale(3.5);
    }
  }

  @media (max-width: 880px) {
    .floor-placeholder {
      transform: scaleY(-1) scale(5);
      -webkit-transform: scaleY(-1) scale(5);
    }

    .floor-placeholder_safari {
      transform: translateY(-100%) scale(5);
      -webkit-transform: translateY(-100%) scale(5);
    }
  }
</style>